import React from "react";
import PropTypes from "prop-types";
import { LiveBlogKeyEvents } from "../../story-page-components/live-blog-key-events";
import { AdService } from "../../ad-service";
import "./key-events-sidebar.module.css";

export const KeyEventsSidebar = ({ story, config, showAd }) => (
  <>
    {showAd && (
      <div styleName="ad">
        <AdService adtype="Story-Mrec" />
      </div>
    )}
    <LiveBlogKeyEvents story={story} config={config} />
  </>
);

KeyEventsSidebar.propTypes = {
  story: PropTypes.object,
  showAd: PropTypes.bool,
  config: PropTypes.object
};
